export default __webpack_public_path__ + "static/media/zx7.91c8bb69.png";